import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pendingTab: {
    currentPage: 1,
    currentFilter: "all",
    currentPageSize: 10,
    sortBy: "",
    sortOrder: "desc",
    search: "",
    clear: false,
  },
  completedTab: {
    currentPage: 1,
    currentFilter: "all",
    currentPageSize: 10,
    sortBy: "",
    sortOrder: "desc",
    search: "",
    clear: false,
  },
  activeTab: "pending",
  pendingSubTab: "invoices",
  showReceiptModal: false,
  selectedInvoiceIds: [],
  selectedCashReceiptId: null,
  summaryData: null,
  showSupplierModal: false,
  selectedSupplier: null,
  receiptPrintData: null,
  // Completed tab — edit / cancel
  editData: null,
  showEditReceiptModal: false,
  showEditSupplierModal: false,
  showCancelModal: false,
  cancelTargetId: null,
};

const invoicesSlice = createSlice({
  name: "deliveryInvoices",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
});

export const { updateConfig, resetConfig } = invoicesSlice.actions;

export default invoicesSlice.reducer;
